<template>
  <div class="task">
    <div class="task-left">
      <div class="task-name">
        {{ task.taskDesc }}
      </div>
      <div v-if="!(task.status === 1)" class="task-progress">
        <div class="progress" :style="{ width: percent + '%' }">
          <span>已完成{{ percent }}%</span>
        </div>
        <span class="text-bg">已完成{{ percent }}%</span>
      </div>
    </div>
    <template v-if="task.status === 3">
      <div class="status" />
      <div class="task-btn" @click="handleClick">立即兑换</div>
    </template>
    <div
      v-else-if="task.status === 2"
      class="task-btn exchange"
      @click="handleGoOrder"
    >
      去下单
    </div>
    <div v-else class="task-btn receive" @click="handleReceiveTask">
      领取任务
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    activityId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      percent: 0
    }
  },
  mounted() {
    if (this.task.status === 1) return
    this.$nextTick(function () {
      setTimeout(() => {
        this.percent = Math.round(
          (this.task.realValue / this.task.targetValue) * 100
        )
      }, 300)
    })
  },
  methods: {
    handleClick() {
      this.$track(this.$trackMap.memberIntegral.TASK_EXCHANGE_BTN)
      document.getElementById('integralExchange').scrollIntoView(true)
    },
    handleGoOrder() {
      this.$track(this.$trackMap.memberIntegral.TASK_GO_ORDER)
      this.$router.push({
        path: '/activity_goods',
        query: {
          promotion_id: this.activityId,
          promote_stage_id: this.task.stageId,
          promote_rule_id: this.task.ruleId
        }
      })
    },
    handleReceiveTask() {
      this.$emit('recive', {
        activityId: this.activityId,
        stageId: this.task.stageId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin bg-image($url) {
  background-image: url($url + '@2x.png');
  @media (-webkit-min-device-pixel-ratio: 3), (min-device-pixel-ratio: 3) {
    background-image: url($url + '@3x.png');
  }
}
.task {
  position: relative;
  display: flex;
  height: 1.4rem;
  justify-content: space-between;
  align-items: center;
  .status {
    position: absolute;
    top: 0;
    right: 1.6rem;
    width: 1.16rem;
    height: 1.16rem;
    z-index: 10;
    background-size: cover;
    background-repeat: no-repeat;
    @include bg-image('~@/images/integral/finish');
  }
  .task-name {
    position: relative;
    color: #333;
    width: 4.5rem;
    line-height: 0.4rem;
    font-weight: 900;
    font-size: 0.32rem;
    z-index: 100;
  }
  .task-progress {
    margin-top: 0.28rem;
    position: relative;
    display: flex;
    align-items: center;
    width: 3.48rem;
    height: 0.24rem;
    overflow: hidden;
    border-radius: 7px;
    background-color: #f3ebe0;
    .progress {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      width: 0;
      border-radius: 7px;
      overflow-x: hidden;
      z-index: 100;
      height: 100%;
      transition: all 2s ease;
      background-image: linear-gradient(to right, #ff7d5e, #ff3410);
      span {
        text-align: center;
      }
    }
    span {
      display: inline-block;
      margin-left: 0.1rem;
      white-space: nowrap;
      width: 100%;
      font-size: 0.2rem;
      line-height: 0.2rem;
      color: rgba(255, 255, 255, 1);
    }
    .text-bg {
      color: #333;
    }
  }
  .task-btn {
    position: relative;
    z-index: 100;
    width: 1.76rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.3rem;
    border-radius: 0.3rem;
    color: #333;
    box-sizing: border-box;
    border: 1px solid #ff3a16;
    background-color: #fff8ef;
    &.exchange {
      border: none;
      color: #fff;
      background-image: linear-gradient(to right, #ff7d5e, #ff3410);
    }
    &.receive {
      border: none;
      color: #fff;
      background-image: linear-gradient(to right, #ffbf34, #ff9025);
    }
  }
}
</style>
